import { amplifyClient, getEndpointV2 } from 'api';
import { createApiSlice } from 'helpers/createApiSlice';
import { call, put, select } from 'redux-saga/effects';
import { companyFetch } from 'store/features/companyFetch';
import { rfcsFetch } from 'store/features/rfcsFetch';
import { userFetch } from 'store/features/userFetch';
import { Company, UserData, UserRFC } from 'types';
type Data = Company;

type Payload = Pick<UserRFC, 'code' | 'companyName'>;

export const rfcCompanyNameUpdate = createApiSlice<Data, Payload>({
  name: 'rfcCompanyNameUpdate',
  *tryGenerator(_, { payload }) {
    const { companyId } = (yield select(userFetch.selectors.getData)) as UserData;
    const { code, companyName } = payload;

    yield call(amplifyClient, {
      method: 'put',
      url: getEndpointV2({
        path: '/auth/company/:companyId/rfc/:code',
        urlParams: { companyId, code },
      }),
      data: {
        name: companyName,
      },
    });

    // updating other states
    yield put(userFetch.actions.call());
    yield put(companyFetch.actions.call());
    yield put(rfcsFetch.actions.call());

    return null;
  },
});
